import JsBarcode from "jsbarcode";
import { useEffect, useRef } from "react";

import styles from "./BarcodePreview.module.scss";

interface Props {
  value: string;
  height?: number;
  fontSize?: number;
  displayValue?: boolean;
}

const BarcodePreview = ({
  value,
  height = 60,
  fontSize = 14,
  displayValue = true
}: Props) => {
  const svgRef = useRef<SVGSVGElement | null>(null);

  useEffect(() => {
    if (!svgRef.current || !value) return;
    try {
      JsBarcode(svgRef.current, value, {
        format: "CODE128",
        displayValue,
        height,
        fontSize,
        margin: 4,
        textMargin: 2,
        background: "#ffffff",
        lineColor: "#000000"
      });
    } catch {
      // jsbarcode throws if value is empty / invalid — swallow and clear
      while (svgRef.current.firstChild) {
        svgRef.current.removeChild(svgRef.current.firstChild);
      }
    }
  }, [value, height, fontSize, displayValue]);

  if (!value) return null;

  return (
    <div className={styles.wrapper}>
      <svg ref={svgRef} />
    </div>
  );
};

export default BarcodePreview;
